import { SEO } from 'src/common/components/seo';
import { Steps as AppSteps } from 'src/common/components/steps';
import { StyledContainer } from './subscriptions.styles';
import { Banner, ManagementDashboard, Voucher } from './components';
import { stepsData } from './subscriptions.constants';
export const Subscriptions: React.FC = () => <>
    <SEO title="Subscriptions" description="TryHackMe is a free online platform for learning cyber security, using hands-on exercises and labs, all through your browser!" data-sentry-element="SEO" data-sentry-source-file="subscriptions.tsx" />
    <Banner data-sentry-element="Banner" data-sentry-source-file="subscriptions.tsx" />
    <StyledContainer data-sentry-element="StyledContainer" data-sentry-source-file="subscriptions.tsx">
      <AppSteps data={stepsData} data-sentry-element="AppSteps" data-sentry-source-file="subscriptions.tsx" />
      <Voucher data-sentry-element="Voucher" data-sentry-source-file="subscriptions.tsx" />
    </StyledContainer>
    <ManagementDashboard data-sentry-element="ManagementDashboard" data-sentry-source-file="subscriptions.tsx" />
  </>;